import styled from 'styled-components/macro';
const SearchWrapper = styled.form`
  margin: 20px;
  overflow-y: auto;
`;

const SearchContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 25px;
`;

const SearchColumn = styled.div`
  padding: 10px;
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const RangeButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  width: 200px;
`;

const InputsContainer = styled.div<{ clickable?: boolean }>`
  position: relative;
  display: flex;
  font-weight: ${({ theme }) => theme.fontWeightPalette.light};
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 15px;
  > div {
    margin-right: 10px;
  }
  input,
  label {
    cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};
  }
`;

const ClickInputsContainer = styled.div``;

const DateLabel = styled.label`
  font-size: ${({ theme }) => theme.fontSizePalette.xxSmall};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
const DateContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0px;
  gap: 10px;
  width: 164px;
`;
const ErrorRange = styled.p<{ right: string; bottom: string }>`
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: 10px;
  color: ${({ theme }) => theme.colorPalette.red};
  text-align: right;
  right: ${({ right }) => right};
  bottom: ${({ bottom }) => bottom};
  position: absolute;
`;
export {
  SearchWrapper,
  SearchContainer,
  SearchColumn,
  ButtonsContainer,
  RangeButtonsContainer,
  InputsContainer,
  ClickInputsContainer,
  DateLabel,
  DateContainer,
  ErrorRange,
};
